
import qs from "query-string";
import type { StringifiableRecord } from "query-string";
import * as R from "ramda";
export interface IOptions {
  params?: StringifiableRecord;
  data?: Record<string, unknown> | FormData;
  method?: "POST" | "GET";
  headers?: Record<string, string>;
  credentials?: RequestCredentials;
  baseUrl?: string;
  returnOrigin?: boolean;
  isFormData?: boolean;
  nodeConfig?: any;
}

function flattenObject(obj: any) {
  const result:any = {};

  function dfs(current: any) {
    if (current == null || typeof current !== 'object' || Array.isArray(current)) {
      return;
    }
    for (const key in current) {
      if (Object.hasOwn(current, key)) {
        const value = current[key];
        if (value != null && typeof value === 'object' && !Array.isArray(value)) {
          dfs(value); // 递归，不保留 key
        } else {
          result[key as string] = value;
        }
      }
    }
  }

  dfs(obj);
  return result;
}

export const qsUrl = (url: string, params: StringifiableRecord, baseUrl?: string) =>
  qs.stringifyUrl(
    { url: `${baseUrl || ''}${url}`, query: flattenObject(params) },
    { skipNull: true, skipEmptyString: true }
  );

const handleError = (error: any) => {
  return Promise.reject(error || "请求失败");
};

export const fetcher = async (url: string, options: IOptions = {}) => {
  const _url = qsUrl(url, options.params || {}, options.baseUrl);
  const method = options.method || "GET";
  if(options.isFormData) {

    return fetch(_url, {
      method,
      headers: {
        ...options.headers,
      },
      body: options.data as unknown as FormData,
      ...options.nodeConfig,
    });
  }
  const res = await fetch(_url, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
    body: method === "GET"
      ? undefined
      : JSON.stringify(options.data || {}),
    credentials: options.credentials,
    ...options.nodeConfig,
  });

  if (options.returnOrigin) {
    return res;
  }

  const data = await res.json();
  if (!data.success) {
   return  handleError(data);
  }
  return data?.data;
};